import LegalPage from '@/components/feature/LegalPage';
import { customerTerms } from '@/data/legal/customerTerms';

export default function CustomerTerms() {
  return <LegalPage doc={customerTerms} />;
}